import React from 'react'

export default function Loading({ label = '불러오는 중…', className = '' }) {
    return (
        <div className={`p-4 text-sm text-slate-600 ${className}`}>{label}</div>
    )
}
